import { getFavouriteQuestions } from "../services/questionService";
export const saveQuestion = (id) => dispatch => {
    dispatch(request(id));

    // functionality to unsave question
    getFavouriteQuestions(id).then((response) => {
        // handle success
        let res = response.data;
        // dispatching success
        dispatch(success(res));

    })
        .catch((error) => {
            // handle error
            dispatch(failure(error.toString()));
        });

    function request(quesId) {
        return { type: 'QUESTION_REQUEST', quesId };
    }

    function success(res) {
        dispatch({
            type: 'TOGGLE_QUESTION__SAVED_SUCCESS',
            payload: {
                questionId: id,

            }
        });
        return {
            type: 'UNSAVE_QUESTION_SUCCESS',
            payload: {
                questionId: id,

            }
        };
    }

    function failure(error) {
        return { type: 'UNSAVE_QUESTIONS_FAILURE', error };
    }

};
